export const OrderWizardMutationTypes = {
  UPDATE_SELECTED_LOYALTY: 'UPDATE_SELECTED_LOYALTY',
  UPDATE_CART: 'UPDATE_CART',
  RESET_SELECTED_LOYALTY: 'RESET_SELECTED_LOYALTY',
  ADD_TO_CART: 'ADD_TO_CART',
  REMOVE_FROM_CART: 'REMOVE_FROM_CART',
  INIT_CART: 'INIT_CART',
  UPDATE_BILLING_CYCLE: 'UPDATE_BILLING_CYCLE',
  CLEAR_CART: 'CLEAR_CART',
  ADD_VEHICLE: 'ADD_VEHICLE',
  REMOVE_VEHICLE: 'REMOVE_VEHICLE',
  UPDATE_VEHICLE_DETAILS_LIST: 'UPDATE_VEHICLE_DETAILS_LIST',
  UPDATE_PACKAGE_OPTIONS: 'UPDATE_PACKAGE_OPTIONS',
  UPDATE_EDITED_VEHICLE_DETAILS_ITEM: 'UPDATE_EDITED_VEHICLE_DETAILS_ITEM',
  STORE_EDITED_VEHICLE_DETAILS: 'STORE_EDITED_VEHICLE_DETAILS',
  CLEAR_VEHICLES: 'CLEAR_VEHICLES',
  UPDATE_ACTIVE_STEP: 'UPDATE_ACTIVE_STEP',
  SAVE_CONTRACT_DATA: 'SAVE_CONTRACT_DATA',
  CLEAR_CONTRACT_DATA: 'CLEAR_CONTRACT_DATA',
  SET_USER_DATA: 'SET_USER_DATA',
  SET_LAST_ORDER_RESPONSE: 'SET_LAST_ORDER_RESPONSE',
  CLEAR_USER_DATA: 'CLEAR_USER_DATA',
  SET_LAST_CHECK_BANK_CARD_PAYMENT_RESPONSE: 'SET_LAST_CHECK_BANK_CARD_PAYMENT_RESPONSE'
}
